import { render, staticRenderFns } from "./AuthorizacionsAdmin.vue?vue&type=template&id=275b4b18"
import script from "./AuthorizacionsAdmin.js?vue&type=script&lang=js&external"
export * from "./AuthorizacionsAdmin.js?vue&type=script&lang=js&external"
import style0 from "./AuthorizacionsAdmin.vue?vue&type=style&index=0&id=275b4b18&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports